import { IBoundProperties, IBoundPropertyValue } from "./types";

export class BoundProperties implements IBoundProperties {
    private list: IBoundPropertyValue[];

    constructor(propertyValues: IBoundPropertyValue[]) {
        this.list = propertyValues;
    }

    public getBinding(id: string): IBoundPropertyValue | undefined {
        return this.list.find(item => item.id === id);
    }

    public getValue<T>(id: string): T | undefined {
        const item = this.getBinding(id);
        if (item) {
            return item.value as T;
        }
        return undefined;
    }
}

